import { Loader2, X } from 'lucide-react';
import { memo } from 'react';

const ChatInputImageAttachment = ({ imageUrl, onClose, isLoading = false }) => (
  <div className="relative h-14 w-14 shrink-0 overflow-hidden rounded-2xl bg-surface-muted">
    {!isLoading && imageUrl ? (
      <img
        src={imageUrl}
        alt=""
        className="h-full w-full object-cover"
      />
    ) : null}
    {isLoading ? (
      <div className="flex h-full w-full items-center justify-center">
        <Loader2 size={20} className="animate-spin text-content-secondary" />
      </div>
    ) : null}
    {onClose ? (
      <button
        type="button"
        onClick={onClose}
        aria-label="Close image"
        className="absolute right-0 top-0 z-[1] inline-flex h-6 w-6 items-center justify-center rounded-full border border-edge bg-surface text-content-secondary hover:bg-surface-hover"
      >
        <X size={16} />
      </button>
    ) : null}
  </div>
);

export default memo(ChatInputImageAttachment);
